import autoImmune from './auto-immune';
import myriad from './myriad';
import neuro from './neuro';

export default {
  autoImmune: autoImmune,
  myriad,
  neuro,
};
